'use client'

import React, { useState } from 'react'
import GridShowSVG from '@/public/icons/gridShow.svg'
import GridShowActiveSVG from '@/public/icons/gridShowActive.svg'
import ListShowSVG from '@/public/icons/listShow.svg'
import ListShowActiveSVG from '@/public/icons/listShowActive.svg'

interface GridListButtonProps {
  lng?: string
  path?: string
}

export default function GridListButton({ lng, path }: GridListButtonProps) {
  const [currentView, setCurrentView] = useState<'grid' | 'list'>('grid')

  const toggleView = (viewType: 'grid' | 'list') => {
    setCurrentView(viewType)

    const gridView = document.getElementById('grid-view')
    const listView = document.getElementById('list-view')

    if (viewType === 'grid') {
      if (gridView) gridView.style.display = 'grid'
      if (listView) listView.style.display = 'none'
    } else {
      if (gridView) gridView.style.display = 'none'
      if (listView) listView.style.display = 'flex'
    }
  }

  return (
    <>
      {currentView === 'grid' ? (
        <div className="hidden items-center gap-2.5 sm:flex">
          <GridShowActiveSVG />
          <ListShowSVG className="cursor-pointer" onClick={() => toggleView('list')} />
        </div>
      ) : (
        <div className="hidden items-center gap-2.5 sm:flex">
          <GridShowSVG className="cursor-pointer" onClick={() => toggleView('grid')} />
          <ListShowActiveSVG />
        </div>
      )}
    </>
  )
}
